import Swal from "sweetalert2";
import { ZodError, ZodType } from "zod";

function isArray(value: unknown): value is Array<unknown> {
  if (Array.isArray(value)) {
    return true;
  }
  return false;
}

// gets an array of zod errors and returns a string
function createErrorString(errors: ZodError["issues"]): string {
  const fullErrorString: string[] = [];

  for (let i = 0; i < errors.length; i++) {
    const field = errors[i].path.join(".");
    const message = errors[i].message;
    const constructedStringError = `${field} - ${message}`;
    fullErrorString.push(constructedStringError);
  }

  return fullErrorString.join("<br>");
}

function fireTypeErrorMessage(errors: ZodError["issues"], tsType: string) {
  const fullErrorString = createErrorString(errors);

  Swal.fire({
    theme: "auto",
    icon: "error",
    title: `Invalid ${tsType}`,
    html: fullErrorString,
    showConfirmButton: true,
    confirmButtonColor: "#3085d6",
  });
}

export function validateWithSchema<T>(
  obj: unknown,
  schema: ZodType<T>,
  typeName: string
): T | false {
  const result = schema.safeParse(obj);
  if (result.success) {
    return result.data;
  }
  // Zod v4: .issues replaces .errors for error details
  console.log(result.error.issues);
  fireTypeErrorMessage(result.error.issues, typeName);

  return false;
}

export function validateArrayWithSchema<T>(
  arr: unknown,
  schema: ZodType<T>,
  typeName: string
): T[] | false {
  if (!isArray(arr)) {
    console.error(`Invalid ${typeName}`, arr);
    Swal.fire({
      theme: "auto",
      icon: "error",
      title: `Invalid ${typeName}`,
      text: `Expected array, got ${typeof arr}`,
    });
    return false;
  }

  const retResult: T[] = [];

  for (const obj of arr) {
    const result = schema.safeParse(obj);
    if (!result.success) {
      // Zod v4: .issues replaces .errors for error details
      console.log(result.error.issues);
      fireTypeErrorMessage(result.error.issues, typeName);
      return false;
    }
    retResult.push(result.data);
  }
  return retResult;
}
